<template>
  <div>
    <div
      class="box-section"
      style="gap: 16px"
      v-for="item in plans"
      :key="item.subscriptionId"
    >
      <div class="name w-200" style="gap: 20px;">
        <img :src="item.logoUrl" :alt="item.coinUnit" />
        <div
          class="d-flex flex-column align-center align-md-start justify-center"
        >
          <div
            class="d-flex align-center justify-center displayName"
            style="gap: 3px"
          >
            <p class="font-Regular-18 onPrimary--text">
              {{ item.displayName }}
            </p>
            <p class="font-Regular-12 onPrimary--text">({{ item.coinUnit }})</p>
          </div>
          <p class="font-Light-14 gray2--text text-wrap w-25">
            {{ item.planDescription }}
          </p>
        </div>
      </div>
      <div class="w-200 d-flex justify-center align-center" style="gap: 5px">
        <div class="badge font-Regular-14" :class="setStatusClass(item.status)">
          {{ setStatus(item.status) }}
        </div>
        <div class="badge font-Regular-14">
          {{ item.duration }} {{ $t("common.day") }}
        </div>
      </div>
      <div
        class="w-200 d-flex flex-md-column align-center justify-space-between onPrimary--text"
        style="gap: 10px"
      >
        <div class="d-flex align-center" style="gap: 8px">
          <v-icon style="width: 24px;height: 24px">$stakingChart</v-icon>
          <span class="font-Regular-14">{{
            $t("staking.stakingPlans.plans.details.currentReward")
          }}</span>
        </div>
        <div class="font-Regular-16 mt-1">
          <span>{{ item.currentReward }}</span
          ><span class="me-1">{{ item.coinUnit }}</span>
        </div>
      </div>
      <div
        class="w-200 d-flex flex-md-column align-center justify-space-between font-Regular-14 onPrimary--text"
        style="gap: 14px"
      >
        <template v-if="activeFilter === 'ACTIVE'">
          <div class="d-flex align-center" style="gap: 8px">
            <v-icon style="width: 24px;height: 24px">$timer</v-icon>
            <span class="">{{
              $t("staking.stakingPlans.plans.details.endSubscriptionTime")
            }}</span>
          </div>
          <span>{{ formatTimes(item.endSubscriptionTime) }}</span>
        </template>
      </div>
      <div
        class="w-200 align-center flex-column font-Regular-14 onPrimary--text d-none d-lg-flex"
      >
        <template v-if="activeFilter === 'ACTIVE' && item.isRenewal">
          <div class="d-flex align-center" style="gap: 8px">
            <v-icon style="width: 24px;height: 24px">$autoRenewal</v-icon>
            <span>{{
              $t("staking.stakingPlans.plans.details.autoRenew")
            }}</span>
          </div>
          <v-switch
            :input-value="item.userApprovedRenewal"
            @change="e => openRenewalDialog(e, item)"
            class="custom-switch"
            hide-details
            inset
          >
            <template v-slot:label>
              <span>
                {{
                  item.userApprovedRenewal
                    ? $t("common.ACTIVATE")
                    : $t("common.DISABLED")
                }}
              </span>
            </template>
          </v-switch>
        </template>
      </div>
      <v-btn
        class="font-Medium-14"
        :loading="loadingId === item.subscriptionId"
        color="primary"
        @click="() => openDialogHandler(item)"
        >{{ $t("staking.stakingPlans.plans.details.View_Details") }}</v-btn
      >
    </div>
    <!--    dialog-->
    <PlanDialog
      v-model="dialog"
      :headerData="coinDto"
      :renewalHistoryItems="renewalHistoryItems"
    />
    <!--    renewal modal-->
    <v-dialog v-model="renewalDialog" width="500" persistent>
      <v-card class="text-center gray13">
        <v-card-text>
          <h2 class="py-4">{{ dialogTitle }}</h2>
          <p>{{ dialogDescription }}</p>
          <v-btn
            :loading="isLoading"
            class="primary"
            @click="confirmRenewal()"
            >{{ confirmButtonText }}</v-btn
          >
          <v-btn class="primary ms-2" @click="cancelRenewal">{{
            $t("common.Return")
          }}</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PlanDialog from "@/components/Staking/MainPage/MyPlans/PlanDialog/PlanDialog.vue";
import StakingService from "@/services/modules/market/staking";
import dayjs from "dayjs";
import Vue from "vue";
import { FiltersType } from "@/store/types";

export default {
  components: { PlanDialog },
  props: ["plans", "activeFilter"],
  provide() {
    return {
      state: this.state,
      CoinDto: null
    };
  },
  data() {
    return {
      dialog: false,
      loadingId: null,
      renewalHistoryItems: [],
      state: Vue.observable({ detailContents: null }), //reactive
      //   auto renewal
      renewalDialog: false,
      tempRenewalStatus: null,
      tempSubscriptionId: null,
      previousRenewalStatus: null,
      localSwitchStatus: null,
      isLoading: false
    };
  },
  methods: {
    setStatus(status) {
      switch (status) {
        case FiltersType.ACTIVE:
          return this.$t("staking.stakingPlans.filters.ACTIVE");
        case FiltersType.TERMINATED:
          return this.$t("staking.stakingPlans.filters.TERMINATED");
        case FiltersType.CANCELED:
          return this.$t("staking.stakingPlans.filters.CANCELED");
        default:
          return "";
      }
    },
    setStatusClass(status) {
      switch (status) {
        case FiltersType.ACTIVE:
          return "badge-success";
        case FiltersType.TERMINATED:
          return "badge-terminated";
        case FiltersType.CANCELED:
          return "badge-error";
        default:
          return "";
      }
    },
    openDialogHandler(item) {
      const id = item.subscriptionId;
      this.loadingId = id;
      const {
        coinUnit,
        logoUrl,
        displayName,
        planDescription,
        planName,
        rewardScale
      } = item;
      this.coinDto = {
        coinUnit,
        logoUrl,
        displayName,
        planDescription,
        planName,
        rewardScale
      };
      this.getMyStakingPlanDetailsData(id);
      this.getRenewalHistoryData(id);
    },
    async getMyStakingPlanDetailsData(id) {
      try {
        const res = await StakingService.getMyStakingPlanDetails(id);
        this.state.detailContents = res.data.data;
        this.dialog = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadingId = null;
      }
    },
    async getRenewalHistoryData(id) {
      try {
        const response = await StakingService.getRenewalHistory(id);
        this.renewalHistoryItems = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    formatTimes(time) {
      const now = dayjs();
      const end = dayjs(time);
      const daysLeft = end.diff(now, "day");
      if (daysLeft > 0) {
        return `${daysLeft}  ${this.$t("common.day")}`;
      } else {
        return this.$t("staking.stakingPlans.plans.details.finishedPlan");
      }
    },
    //   auto renewal
    openRenewalDialog(status, item) {
      this.previousRenewalStatus = item.userApprovedRenewal;
      this.tempRenewalStatus = status;
      this.tempSubscriptionId = item.subscriptionId;
      this.renewalDialog = true;

      // به روز رسانی موقت UI
      this.$set(item, "userApprovedRenewal", status);
    },
    confirmRenewal() {
      const payload = {
        isAutoRenewal: this.tempRenewalStatus,
        subscriptionId: this.tempSubscriptionId
      };

      this.isLoading = true;

      StakingService.updateRenewalStatus(payload)
        .then(res => {
          if (res.data.code !== 0) {
            const itemIndex = this.plans.findIndex(
              plan => plan.subscriptionId === this.tempSubscriptionId
            );
            if (itemIndex !== -1) {
              this.$set(
                this.plans[itemIndex],
                "userApprovedRenewal",
                this.previousRenewalStatus
              );
            }
          }
        })
        .catch(error => {
          console.error("Error updating renewal status:", error);
          // در صورت خطا نیز مقدار را بازگردانید
          const itemIndex = this.plans.findIndex(
            plan => plan.subscriptionId === this.tempSubscriptionId
          );
          if (itemIndex !== -1) {
            this.$set(
              this.plans[itemIndex],
              "userApprovedRenewal",
              this.previousRenewalStatus
            );
          }
        })
        .finally(() => {
          this.renewalDialog = false;
          this.isLoading = false;
          this.tempRenewalStatus = null;
          this.tempSubscriptionId = null;
          this.previousRenewalStatus = null;
        });
    },
    cancelRenewal() {
      const itemIndex = this.plans.findIndex(
        plan => plan.subscriptionId === this.tempSubscriptionId
      );

      if (itemIndex !== -1) {
        this.$set(
          this.plans[itemIndex],
          "userApprovedRenewal",
          this.previousRenewalStatus
        );
      }

      this.tempRenewalStatus = null;
      this.tempSubscriptionId = null;
      this.previousRenewalStatus = null;
      this.renewalDialog = false;
    }
  },
  computed: {
    switchStatus: {
      get() {
        return this.localSwitchStatus;
      },
      set(newStatus) {
        this.localSwitchStatus = newStatus;
      }
    },
    dialogTitle() {
      return this.tempRenewalStatus
        ? this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Enable_Auto_Renewal"
          )
        : this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Disable_Auto_Renewal"
          );
    },
    dialogDescription() {
      return this.tempRenewalStatus
        ? this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Auto_Renewal_Description"
          )
        : this.$t(
            "staking.stakingPlans.dialogDetail.planSchedule.Auto_Renewal_Disabled_Description"
          );
    },
    confirmButtonText() {
      return this.tempRenewalStatus
        ? this.$t("common.Enable")
        : this.$t("common.Disable");
    }
  }
};
</script>

<style lang="scss">
.w-200 {
  width: 100%;
}
.box-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 40px 0;
  padding: 16px 16px;
  background: var(--v-gray10-base);
  flex-direction: column;
  border-radius: 16px;

  .name {
    text-align: center;
    margin-top: 12px;
    .displayName {
      margin-inline: auto;
    }
    img {
      max-width: 40px;
      height: 40px;
    }
  }
}

@media screen and (min-width: 961px) {
  .w-200 {
    width: 200px;
    max-width: 200px;
  }
  .box-section {
    flex-direction: row;
    padding: 0 16px;
    .name {
      display: flex;
      align-items: center;
      .displayName {
        margin-inline: unset;
      }
      text-align: start;
      img {
        margin-bottom: 12px;
      }
    }
  }
}
.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--v-gray8-base);
  color: var(--v-onPrimary-base);
  border-radius: 4px;
  width: 70px;
  height: 25px;
}
.badge-success {
  background-color: var(--v-successTransparent-base) !important;
  color: var(--v-success-base) !important;
}
.badge-error {
  background-color: var(--v-errorTransparent-base) !important;
  color: var(--v-error-base) !important;
}
.badge-terminated {
  background-color: var(--v-infoTransparent-base) !important;
  color: var(--v-info-base) !important;
}
</style>
